interface TabConfig {
  name: string;
  key: string;
  [key: string]: any;
}

export function getModalMessage(
  affectedTabKey: string | null,
  editedTabs: Record<string, boolean>,
  tabsConfig: TabConfig[],
  __: (text: string) => string
): string {
  const keysToCheck = affectedTabKey
    ? [affectedTabKey]
    : Object.keys(editedTabs).filter((key) => Boolean(editedTabs[key]));

  if (keysToCheck.length === 0) {
    return __(
      "Masz niezapisane zmiany w tej zakładce. Czy na pewno chcesz opuścić tę zakładkę? Niezapisane zmiany zostaną utracone."
    );
  }

  const unsavedTabsName = keysToCheck
    .map((key) => {
      const tab = tabsConfig.find((el) => el.key === key);
      return tab ? tab.name : null;
    })
    .filter(Boolean);

  if (unsavedTabsName.length === 1) {
    return `${__("Masz niezapisany formularz w zakładce")} ${
      unsavedTabsName[0]
    }. ${__("Niezapisane zmiany zostaną utracone")}.`;
  }

  return `${__("Masz niezapisane formularze w zakładkach")}:${
    unsavedTabsName.length > 0 ? ` ${unsavedTabsName.join(", ")}.` : ""
  } ${__("Niezapisane zmiany zostaną utracone")}.`;
}
